import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=15285486"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Language: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Language/Language.vue').default,Nav: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Nav.vue').default,Header: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Header.vue').default})
